<template>
  <div v-show="visible" class="modal__getArhive">
    <div class="modal-content" v-if="isSend">
      <div class="modal-header">
        <h4 class="modal-title getArhive__title">Запрос на сбор архива успешно выполнен</h4>
        <button type="button" class="close popap__btn-close" @click="hide">
          <i><img src="/img/ic_close_chip.svg" alt=""></i>
        </button>
      </div>
      <div class="modal-body">
        <p class="modal__getArhive__text">
          Подготовка архива с данными референсов занимает некоторое время.
          После формирования архива ссылка для скачивания придет на указанный e-mail <strong>{{ email }}</strong>.</p>
        <button @click="hide" type="button" class="btn popap__content-btn success-modal-btn">ОК</button>
      </div>
    </div>
    <div class="modal-content" v-else>
      <div class="modal-header">
        <h4 class="modal-title getArhive__title">Для получения архива укажите ваш e-mail</h4>
        <button type="button" class="close popap__btn-close" @click="hide">
          <i><img src="/img/ic_close_chip.svg" alt=""></i>
        </button>
      </div>
      <div class="modal-body">
        <p class="modal__getArhive__text">
          Подготовка архива с данными референса занимает некоторое время.
          Ваш запрос будет поставлен в очередь на обработку. По завершению создания
          архива на указанную почту будет отправлена ссылка для скачивания файла.
        </p>
        <form class="getArhive__form" style="margin: 30px 0 10px 0">
          <div class="getArhive__email-wrap" :class="{ 'has-error': errors.email }">
            <input class="getArhive__form-email" type="text" placeholder="Ваш E-mail" v-model.lazy.trim="email">
            <button class="getArhive__form-btn btn greenBtnCondition" type="button" @click="sendRequest">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="6" width="14" height="12" rx="1" stroke="#fff" stroke-width="2" />
                <path d="M5 7L11.9419 11.9585C11.9766 11.9833 12.0234 11.9833 12.0581 11.9585L19 7"
                      stroke="#fff" stroke-width="2" />
              </svg>
              Получить архив
            </button>
            <div v-if="errors.email" class="help-block">{{errors.email}}</div>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-backdrop show" @click="hide"></div>
  </div>
</template>

<script>

export default {
  name: "product-modal",
  components: {},
  props: {
    product_id: {
      require: true
    }
  },
  data: () => ({
    isSend: false,
    submiting: false,
    errors: {},
    email: '',
    visible: false,
    categories: []
  }),
  created() {
  },
  mounted () {
    this.$root.$on('product-archive-modal::show', (data) => {
      this.show(data.categories)
    })
  },
  methods: {
    show (categories) {
      this.resetModel()
      this.categories = categories
      document.body.classList.add('modal-open')
      this.visible = true
    },
    hide () {
      document.body.classList.remove('modal-open')
      this.visible = false
      this.resetModel()
    },
    sendRequest () {
      this.$api.archive.requestArchive({ email: this.email, productIds: [this.product_id], categories: this.categories, includeEmpty: true }).then(() => {
        this.submiting = false
        this.isSend = true
      }).catch((error) => {
        this.errors = {}
        if (error.response && error.response.status === 422) {
          error.response.data.forEach((validationError) => {
            this.errors[validationError.field] = validationError.message
          })
        }
        this.submiting = false
      })
    },
    resetModel () {
      this.errors = {}
      this.email = ''
      this.productIds = []
      this.includeEmpty = true
      this.isSend = false
    },
  }
}
</script>

